import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";

export const TitleSubLoader = () => {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton
        width={"20%"}
        height={"24px"}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
      />

      <Skeleton
        width={"100%"}
        height={"20px"}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
      />
    </div>
  );
};
